"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowCheckBoxEditor_1 = require("../../../../../../../../shared/components/editors/CardRowCheckBoxEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var AffilateLanguageEditor = /** @class */ (function (_super) {
    __extends(AffilateLanguageEditor, _super);
    function AffilateLanguageEditor(props) {
        return _super.call(this, props) || this;
    }
    AffilateLanguageEditor.prototype.componentWillMount = function () {
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    app_language_id: _item.app_language_id,
                    app_language_title: _item.app_language_title,
                    is_default: _item.is_default,
                });
            }
        }
        else {
            this.setState({
                app_language_id: 0,
                app_language_title: "",
                is_default: false
            });
        }
        this.doReSetRules();
    };
    AffilateLanguageEditor.prototype.doReSetRules = function () {
        this.setState({
            app_language_rules: { isError: false },
        });
    };
    AffilateLanguageEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.app_language_id <= 0) || (this.state.app_language_title.length === 0)) {
            this.setState({ app_language_rules: { isError: true, errorMessage: "Язык не выбран!" } });
            return false;
        }
        return true;
    };
    /*private OnUpdateDataClick() {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                app_language_id: this.state.app_language_id,
                is_default: this.state.is_default
            }, () => {
                notificationHelper.ShowTextTopRightInfoNotify("Язык аффилейта изменен!");
            })
        }
    }*/
    AffilateLanguageEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_language_id: this.state.app_language_id,
                affilate_id: this.props.rootRecord.key,
                is_default: this.state.is_default
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Язык П.Программы добавлен!");
            });
        }
    };
    AffilateLanguageEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    AffilateLanguageEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить язык П.Программы";
        }
        else {
            return "Изменить язык П.Программы";
        }
    };
    AffilateLanguageEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 300 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык:", placeholder: "Выберите язык" }, value: { key: this.state.app_language_id, value: this.state.app_language_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_language_id: newVal.key,
                        app_language_title: newVal.value,
                        app_language_rules: { isError: false }
                    });
                }, items: this.props.availLanguage, required: true, rules: this.state.app_language_rules }),
            React.createElement(CardRowCheckBoxEditor_1.default, { title: "Основной язык", value: this.state.is_default, onChecked: function (checked) { _this.setState({ is_default: checked }); } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { /*btnEdit: "Сохранить",*/ btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this) })));
    };
    return AffilateLanguageEditor;
}(React.Component));
exports.default = AffilateLanguageEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/par_pprograms_list/ui/component/config/language/AffilateLanguageEditor.tsx
// module id = 2016
// module chunks = 0